import { ISubscriptionPaymentSummary } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  paymentSubscriptionSummary?: ISubscriptionPaymentSummary;
}

export const OrderSummaryNote: FunctionComponent<IProps> = ({ paymentSubscriptionSummary }) => {
  if (!paymentSubscriptionSummary?.orderSummaryNote) {
    return <></>;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{paymentSubscriptionSummary.orderSummaryNote}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Theme.GREY_FIGMA_LIGHT,
    padding: defaultScale(15),
    marginBottom: defaultScale(15),
  },
  text: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_FIGMA_MEDIUM_LIGHT,
  },
});
